import React from 'react';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import {
  login,
  LOGIN_TYPE_NPI,
} from 'actions/login';

// Logs in the user with the provided npiNumber.
const AutoLoginButton = ({buttonLabel, npiNumber, className, errorMessages}) => {
  const dispatch = useDispatch();

  const _handleSubmitNPI = (npiNumber) => {
    dispatch(login(
      LOGIN_TYPE_NPI,
      npiNumber,
      errorMessages.apiUnavailable,
      errorMessages.npiIncorrect
    ));
  };

  const buttonClasses = `btn btn-primary ${className}`;
  return (
    <button
      className={buttonClasses}
      onClick={() => {
        _handleSubmitNPI(npiNumber)
      }}
    >
      {buttonLabel}
    </button>
  );
};

AutoLoginButton.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  npiNumber: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  className: PropTypes.string
};


export default AutoLoginButton;